import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';

import { useJobBoardParams } from '@/hooks/JobBoardFilters/useJobBoardParams';
import useForm from '@/hooks/useForm';

import SearchInput from '../SearchInput';

export const JOB_TITLE_FORM_ID = 'job-board-job-title-form';

type JobTitleFormValues = { search: string };

const JobTitle = () => {
  const { isReady } = useRouter();

  const {
    setParams,
    params: { search: searchParam },
  } = useJobBoardParams();

  const { control, handleSubmit, reset } = useForm<JobTitleFormValues>({
    defaultValues: { search: searchParam ?? '' },
  });

  useEffect(() => {
    if (!isReady) return;
    reset({ search: searchParam ?? '' });
  }, [isReady, searchParam, reset]);

  return (
    <form
      id={JOB_TITLE_FORM_ID}
      className="flex w-full items-center"
      onSubmit={handleSubmit(({ search }) =>
        setParams({ search: search || undefined })
      )}
    >
      <Controller
        control={control}
        name="search"
        render={({ field: { onChange, value } }) => (
          <SearchInput
            inputProps={{
              value,
              onChange,
              className: 'border-none text-jb-neutral-900',
              canHaveErrorMessage: false,
            }}
          />
        )}
      />
    </form>
  );
};

export default JobTitle;
